import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesUp, faAnglesDown, faPlusSquare, faMinusSquare } from "@fortawesome/free-solid-svg-icons";
import SearchField from "../SearchField/SearchField";
import {
  handlePaytermInputChange,
  handlePaytermInputBlur,
  SelectPayType,
  handleDelPayRow,
  handleAddPayRow,
} from "./utils/inputhandlers";
import useSPPosition from "../../hooks/useSPPosition";
import useSPUndo from "../../hooks/useSPUndo";
import SPPositionFormGroup from "./SPPositionFormGroup";

const PositionsSPPayment = ({ ignoreEnter, clearfield, loadedPayterm, loadedPaytermData }) => {
  const { SPpaymentterm, setSPPaymentterm, SPpaymenttermData, setSPPaymenttermData, SPpayrow, positiontoeditSP } =
    useSPPosition();
  const {
    setEditingFieldSP,
    positionEditsSP,
    editIDSP,
    setEditIDSP,
    editingFieldSP,
    undoListSP,
    setReloadpaytermsSP,
    inputRefsSP,
  } = useSPUndo();
  return (
    <fieldset>
      <legend>
        Payment Terms:
        <FontAwesomeIcon
          icon={faPlusSquare}
          onClick={(e) =>
            handleAddPayRow(
              setSPPaymentterm,
              setSPPaymenttermData,
              SPpayrow,
              positionEditsSP,
              editIDSP,
              setEditIDSP,
              undoListSP,
              loadedPayterm,
              loadedPaytermData,
              positiontoeditSP
            )
          }
        />
      </legend>
      <SPPositionFormGroup
        labelname={"Interest Rate"}
        inputname={"interest"}
        inputtype={"percent"}
        style={{ minWidth: "45px", maxWidth: "55px", marginBottom: "1rem", textAlign: "right" }}
      />
      <div className='SPpayterms'>
        <div className='SPpayterm-headers'>
          <p></p>
          <p>Portion</p>
          <p>Type</p>
          <p>Days</p>
        </div>
        {SPpaymentterm &&
          SPpaymentterm.map((el, ind) => {
            // console.log(paymentterm);
            let paykeys = Object.keys(el);
            return (
              <div key={"posrowpay-" + ind} className='SPpayterm-content'>
                <p>{ind + 1 + ":"}</p>
                {paykeys &&
                  paykeys.map((el1) => {
                    if (el1 !== "positionID" && el1 !== "posPaytermID" && el1 !== "row" && el1 !== "type") {
                      if (el1 !== "payType") {
                        return (
                          <input
                            required
                            id={el1 + ind}
                            autoComplete='off'
                            key={ind + "-" + el1}
                            name={el1}
                            value={el[el1]}
                            onFocus={(e) => e.target.select()}
                            onChange={(e) => {
                              handlePaytermInputChange(
                                ind,
                                el1,
                                e,
                                SPpaymentterm,
                                SPpaymenttermData,
                                setSPPaymentterm,
                                setSPPaymenttermData,
                                setEditingFieldSP
                              );
                            }}
                            onBlur={(e) => {
                              handlePaytermInputBlur(
                                ind,
                                el1,
                                e,
                                SPpaymentterm,
                                setSPPaymentterm,
                                positionEditsSP,
                                editingFieldSP,
                                editIDSP,
                                setEditIDSP,
                                setEditingFieldSP,
                                undoListSP,
                                SPpaymenttermData
                              );
                            }}
                            onKeyDown={ignoreEnter}
                            ref={(elem) => {
                              return (inputRefsSP.current[el1 + (el?.posPaytermID || el?.row)] = elem);
                            }}
                          />
                        );
                      } else {
                        return (
                          <SearchField
                            key={ind + "-" + el1}
                            required={true}
                            searchURL='/api/positions/getpaytypes'
                            value={el[el1] || ""}
                            valueName='payType'
                            refName={"payType" + (el.posPaytermID || el.row)}
                            valueID='payTypeID'
                            style={{ width: "40px" }}
                            customplaceholder='payType'
                            onItemSelect={(item) => {
                              SelectPayType(
                                item,
                                ind,
                                SPpaymentterm,
                                setSPPaymentterm,
                                SPpaymenttermData,
                                setSPPaymenttermData,
                                editingFieldSP,
                                positionEditsSP,
                                editIDSP,
                                el1,
                                setEditIDSP,
                                setEditingFieldSP,
                                undoListSP
                              );
                            }}
                            clearfield={clearfield}
                          />
                        );
                      }
                    }
                  })}
                <p>
                  <FontAwesomeIcon
                    style={{ marginLeft: "0.4rem" }}
                    icon={faMinusSquare}
                    onClick={(e) =>
                      handleDelPayRow(
                        SPpaymentterm,
                        SPpaymenttermData,
                        setSPPaymentterm,
                        setSPPaymenttermData,
                        setReloadpaytermsSP,
                        ind,
                        positionEditsSP,
                        editIDSP,
                        setEditIDSP,
                        undoListSP,
                        SPpayrow,
                        loadedPayterm,
                        loadedPaytermData
                      )
                    }
                  />
                </p>
              </div>
            );
          })}
      </div>
    </fieldset>
  );
};

export default PositionsSPPayment;
